import axiosClient from '@/api/axiosClient';
import {
  API_CLONE_PRIZE_MANAGEMENT,
  API_CREATE_PRIZE_MANAGEMENT,
  API_GET_PRIZE_MANAGEMENT,
  API_UPDATE_PRIZE_MANAGEMENT,
} from '@/config/paths/API_PATH';

async function getPrizeManagement({ name, isActive, startTime = null, endTime = null }) {
  const { data } = await axiosClient.get(API_GET_PRIZE_MANAGEMENT, {
    params: {
      name: name,
      is_active: isActive,
      start_time: startTime,
      end_time: endTime,
    },
  });

  return data;
}

async function editPrizeManagement(formData) {
  const { data } = await axiosClient.post(API_UPDATE_PRIZE_MANAGEMENT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data;
}

async function clonePrizeManagement() {
  const { data } = await axiosClient.post(API_CLONE_PRIZE_MANAGEMENT);

  return data;
}

async function createPrizeManagement(formData) {
  const { data } = await axiosClient.post(API_CREATE_PRIZE_MANAGEMENT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data;
}

export { getPrizeManagement, editPrizeManagement, clonePrizeManagement, createPrizeManagement };
